import React from "react";
export const ArrowForward = ({ color }) => (
  <svg width={24} height={24} fill="none" className="icn-arrow-forward">
    <path
      d="M12 4l-1.41 1.41L16.17 11H0v2h16.17l-5.58 5.59L12 20l8-8-8-8z"
      fill={color || "#582841"}
    />
  </svg>
);
